import { render, staticRenderFns } from "./room_tab_config.vue?vue&type=template&id=099c9454&scoped=true"
import script from "./room_tab_config.vue?vue&type=script&lang=js"
export * from "./room_tab_config.vue?vue&type=script&lang=js"
import style0 from "./room_tab_config.vue?vue&type=style&index=0&id=099c9454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c9454",
  null
  
)

export default component.exports